import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Link } from '@99designs/emu';
import { spaces } from '@99designs/emu/settings';
import { IconDown1 } from '@99designs/icons';

const Pagination = styled.div`
    margin: ${spaces['2bu']};
    text-align: center;
`;

interface Props {
    fetchMore: () => void;
}

function DesignerResultsPagination(props: Props) {
    const { fetchMore } = props;
    const [scrollPosition, setScrollPosition] = useState(window.pageYOffset);

    useEffect(() => {
        window.scrollTo(0, scrollPosition);
    }, [scrollPosition]);

    return (
        <Pagination>
            <Link
                onClick={() => {
                    fetchMore();
                    setScrollPosition(window.pageYOffset);
                }}
            >
                {__('Show more')}
                <IconDown1 offsetLeft />
            </Link>
        </Pagination>
    );
}

export default DesignerResultsPagination;
